import { cx } from 'class-variance-authority';
import localFont from 'next/font/local';
import { getTranslations } from 'next-intl/server';
import type { PropsWithChildren } from 'react';
import type { Messages } from 'types/locale-messages';
import ErrorPageNavigation from '@/app/components/Navigation/ErrorPageNavigation';
import { openGraph } from '@/metadata/seoConfig';

const AkkuratLL = localFont({
  src: [
    {
      path: '../../fonts/AkkuratLL-Regular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: '../../fonts/AkkuratLL-Light.woff2',
      weight: '300',
      style: 'light',
    },
  ],
  variable: '--font-sans',
});

const EditorialNew = localFont({
  src: [
    {
      path: '../../fonts/PPEditorialNew-Ultralight.woff2',
      weight: '200',
      style: 'normal',
    },
    {
      path: '../../fonts/PPEditorialNew-UltralightItalic.woff2',
      weight: '200',
      style: 'italic',
    },
  ],
  variable: '--font-serif',
});

export async function getMetadata(titleKey: keyof Messages) {
  const t = await getTranslations();
  return {
    title: t(titleKey),
    openGraph: {
      ...openGraph,
      title: t(titleKey),
    },
  };
}

type ErrorPageShellProps = PropsWithChildren<{
  readonly lang?: string;
  readonly navigation?: React.ReactNode;
}>;

/**
 * Standalone document for pages that render outside the locale layout's
 * provider tree, such as the root not-found and the maintenance-mode page.
 */
export function ErrorPageShell({
  children,
  lang = 'en',
  navigation = <ErrorPageNavigation />,
}: ErrorPageShellProps) {
  return (
    <html
      className={cx(AkkuratLL.variable, EditorialNew.variable, 'nojs')}
      lang={lang}
    >
      <body className={cx('tailwind')}>
        {navigation}
        {children}
      </body>
    </html>
  );
}
